<div id="team" class="team-area">
  <div class="container">
    <div class="section-title">
      <h2>Nuestro <span>Equipo</span></h2>
      <p>Estos son algunos de los miembros de nuestro centro de investigaciones.</p>
    </div>

    <div class="team-carousel" aria-label="Miembros del equipo">
      <div class="team-track">
        @for (copy of [0, 1]; track copy) {
          <div class="team-group" [attr.aria-hidden]="copy === 1">
            @for (member of teamMembers; track member) {
              <div class="single-team-box">
                <div class="image">
                  @if (member.image) {
                    <img [src]="member.image" [alt]="member.name">
                  } @else {
                    <div class="image-placeholder" aria-hidden="true"><i class="far fa-user"></i></div>
                  }
                </div>
                <div class="content">
                  <h3 class="title">{{ member.name }}</h3>
                  <span class="post" [class.post--director]="isDirector(member.role)">{{ member.role }}</span>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
  <div class="shape1"><img src="assets/img/shape1.png" alt="image" loading="lazy"></div>
</div>
